module.exports = __webpack_public_path__ + "img/xiahuaxian.488dce46.svg";